
import React, { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import { useLanguage } from '../i18n/LanguageContext';

const counterData = [
    { number: 1, suffix: '', title: 'Platform', label: 'One place for every library, plan and training session.' },
    { number: 1000, suffix: '+', title: 'Exercises', label: 'Movements, drills, and progressions across the platform.' },
    { number: 4, suffix: '', title: 'Libraries', label: 'Hypertrophy, athletic performance, mobility and kettlebell.' },
    { number: 1, suffix: '', title: 'Custom Program', label: 'Your personalized blueprint, built around your goals.' },
];

const CounterBlog = () => {
    const { t } = useLanguage();
    const gridRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const grid = gridRef.current;

        if (!grid) {
            return undefined;
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReducedMotion) {
            setIsVisible(true);
            return undefined;
        }

        if (!('IntersectionObserver' in window)) {
            setIsVisible(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.24 },
        );

        observer.observe(grid);

        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={gridRef}
            className={`counter-blog-grid${isVisible ? ' is-visible' : ''}`}
        >
            {counterData.map((item, ind) => (
                <article className="counter-blog-card" key={item.title}>
                    <span className="counter-blog-index">{String(ind + 1).padStart(2, '0')}</span>
                    <div className="counter-blog-content">
                        <h3 className="title counter">
                            <CountUp
                                start={0}
                                end={item.number}
                                duration={2.8}
                                enableScrollSpy
                                scrollSpyOnce
                                separator=","
                            />
                            {item.suffix}
                        </h3>
                        <p className="counter-blog-title">{t(item.title)}</p>
                        <p className="counter-blog-label">{t(item.label)}</p>
                    </div>
                </article>
            ))}
        </div>
    );
};

export default CounterBlog;
